<template>
  <v-container>
    <v-layout>
      <v-flex>
        <h3 class="headline mt-3">{{$t('Applicants')}}</h3>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn outline color="primary" :loading="loading" @click="exportWorkstyle()">Export</v-btn>
        <!-- <v-btn outline color="primary" @click="showSearch = !showSearch">
          <v-icon class="mr-1">search</v-icon>Search
          <v-icon class="ml-1">{{showSearch ? 'arrow_drop_up':'arrow_drop_down'}}</v-icon>
        </v-btn>-->
      </v-flex>
    </v-layout>

    <!-- <filter-applicant v-model="filters" v-if="showSearch" @onSearch="onSearch"></filter-applicant> -->

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <work-style v-model="props.item"></work-style>

        <!-- <customer-item v-model="props.item"></customer-item> -->
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No applicant') }}</div>
    </v-data-table>

    <div class="text-xs-center mt-4">
      <v-btn
        outline
        color="primary"
        :loading="loading"
        :disabled="!hasNext"
        @click="getMoreApplicants"
      >{{ $t('Next') }}</v-btn>
    </div>
    <div class="mb-5 mt-5"></div>
  </v-container>
</template>

<script>
import api from '@/api'
import WorkStyle from './WorkStyle'
import FilterApplicant from './FilterApplicant'
export default {
  data() {
    var headers = []

    headers = headers.concat([
      { text: this.$t('Name'), value: 'first_name' },
      { text: this.$t('Workstyle'), value: 'workstyle' },
      { text: this.$t('Total'), value: 'total' },
      { text: this.$t('Answer'), value: 'answer' }
    ])

    return {
      showSearch: false,
      filteredHeader: [],
      pagination: { rowsPerPage: -1, sortBy: '' },
      loading: true,
      hasNext: false,
      limit: 100,
      offset: 0,
      headers: headers,
      users: [],
      filters: {
        urlsource: null,
        interest: null,
        first_name: null,
        last_name: null,
        email: null,
        phoneno: null,
        lineid: null,
        educationlevel: null,
        institution: null,
        major: null,
        gpa: null
      }
    }
  },
  components: {
    FilterApplicant,
    WorkStyle
  },
  async mounted() {
    this.loading = true
    try {
      var users = await this.getWorkStyleResult(this.limit, this.offset)
      this.offset += this.limit
      this.users = this.users.concat(users)
      this.loading = false
    } catch (error) {
      console.log(error)
      this.loading = false
    }
  },
  methods: {
    async onSearch() {
      this.loading = true
      try {
        this.offset = 0
        this.users = []
        var users = await this.getWorkStyleResult(this.limit, this.offset)
        this.offset += this.limit
        this.users = this.users.concat(users)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    getWorkStyleResult: function(limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = vm.filters
        data.pageid = vm.pageid
        data.limit = limit
        data.offset = offset

        api.getWorkStyleResult(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    async getMoreApplicants() {
      this.loading = true
      try {
        var users = await this.getWorkStyleResult(this.limit, this.offset)
        this.offset += this.limit
        this.users = this.users.concat(users)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    onFailLoad: function(index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    exportWorkstyle: async function(offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 10000
      vm.loading = true

      try {
        var workstyles = await this.getWorkStyleResult(limit, offset)

        if (workstyles && workstyles.length > 0) {
          csvContent += 'Name,Workstyle,Total,Answer'

          csvContent += '\r\n'

          $.each(workstyles, function(index, val) {
            let row = ''

            row +=
              '"' +
              `${val.first_name ? val.first_name : ''} ${val.last_name ? val.last_name : ''}` +
              '",'

            row += `"${val.workstyle ? val.workstyle : '-'}",`
            row += `"${val.total ? val.total : '-'} (${
              val.total > 0 ? parseInt((val.total * 100) / 8) : 0
            }%)",`
            row += `"${val.answer ? val.answer.replace(/\r?\n|\r/g, ' / ') : '-'}"`

            csvContent += row + '\r\n'
          })

          vm.exportCsv(csvContent, 'workstyle_' + offset)

          offset += limit
          if (workstyles.length >= limit) {
            vm.exportWorkstyle(offset)
          } else {
            vm.loading = false
          }
        }
      } catch (error) {
        vm.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/scgcareer/WorkStyles.vue